import React from "react";
import { FiPieChart, FiUsers, FiUser, FiArchive } from "react-icons/fi";

export type OptionsDrawerType = {
  name: string;
  pathRoute?: string;
  icon: JSX.Element;
  subList?: OptionsDrawerType[];
};

const DRAWER_OPTIONS: OptionsDrawerType[] = [
  {
    name: "Dashboard",
    icon: <FiPieChart />,
    pathRoute: "/admin/dashboard",
  },
  {
    name: "Módulos",
    icon: <FiArchive />,
    pathRoute: "/admin/modules",
  },
  {
    name: "Colaboradores",
    icon: <FiUser />,
    pathRoute: "/admin/users",
  },
  {
    name: "Alunos",
    icon: <FiUsers />,
    pathRoute: "/admin/students",
  },
  // {
  //   name: "Configurações",
  //   icon: <FiSettings />,
  //   pathRoute: "/admin/configs",
  // },
];

export default DRAWER_OPTIONS;
